import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../../services/Validator";

export default function ExerciserQuestionText({question}) {
    // Used through the app to display Exerciser question
    // text

    // BUILD
    if (isNullOrUndefined(question))
        return null
    return (
        <div className={"w-full text-center px-[24px] mt-[32px]"}>
            <MathJaxContext>
                <MathJax inline dynamic>
                    <span className="whitespace-pre-line font-semibold text-[20px] md:text-[22px] text-white">
                        {question ?? "Erreur"}
                    </span>
                </MathJax>
            </MathJaxContext>
        </div>
    );
}